// Catch-all splat route. Handles two things:
//   1) Wix → Lovable 301 redirects for the travelbackland.com migration.
//   2) Renders the root 404 for anything else.
import { createFileRoute, redirect, notFound } from "@tanstack/react-router";
import { resolveWixRedirect } from "@/lib/wix-redirects";

export const Route = createFileRoute("/$")({
  beforeLoad: ({ location }) => {
    const dest = resolveWixRedirect(location.pathname);
    if (dest) {
      throw redirect({ href: dest, statusCode: 301 });
    }
    throw notFound();
  },
  component: () => null,
});
